import React, { useState } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { Formik, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import Overlay from "../../../components/Overlay";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import jobDashLogo from "../../../assets/images/jobDashlogo.png";
import axios from "../../../axios";
import Input from "../../../components/Input";
import { IoArrowBackOutline } from "react-icons/io5";
import {
  getAddressFromLatLng,
  getGeoLocation,
  getPublicIP,
  getTimezone,
} from "../../../utils/functions";

const useStyles = makeStyles(() => ({
  formStyle: {
    width: "100%",
    overflow: "scroll",
  },
}));

// password validator
const passwordValidator = (values) => {
  const errors = {};

  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};

const ConfirmPassword = ({ setUsers, userData }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const handleConfirmPassword = async (values) => {
    setIsLoading(true);

    try {
      const otpData = JSON.parse(localStorage.getItem("otpData") || "{}");
      const userId = otpData?.userId;

      if (!userId) {
        toast.error("User ID missing. Please try again.");
        setIsLoading(false);
        return;
      }

      // ===== SAFE GEO FETCH (won't block main API) =====
      let publicIp = "";
      let timezone = "";
      let city = "";

      try {
        const ipRes = await getPublicIP();
        publicIp = ipRes?.ip || "";

        timezone = await getTimezone();

        const location = await getGeoLocation();

        if (location?.lat && location?.lon) {
          const address = await getAddressFromLatLng(
            location.lat,
            location.lon
          );
          city = address?.address?.city || "";
        }
      } catch (geoError) {
        console.warn("Geo/location fetch failed:", geoError);
      }

      // ===== MAIN PAYLOAD =====
      const payload = {
        _id: userId,
        password: values.password,
        confirmPassword: values.confirmPassword,
        timezone,
        location: city,
      };

      console.log("Submitting payload:", payload);

      // ===== PASSWORD API =====
      const response = await axios.post("/forgetPassword", payload);

      if (response?.status === 200) {
        toast.success("Password updated successfully!");
        localStorage.removeItem("otpData");
        navigate("/");
      }
    } catch (error) {
      console.error(error);

      const status = error?.response?.status;

      if (status === 422) {
        toast.error(
          error?.response?.data?.errors?.[0]?.msg || "Validation error"
        );
      } else {
        toast.error(
          error?.response?.data?.message || "Something went wrong"
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="auth">
      <div className="login">
        <div className="login-text-cant">
          <img
            src={jobDashLogo}
            style={{ height: "75px", width: "97px" }}
            alt="logo"
          />
        </div>

        <div className="logincontainer">
          <div className="login-main-cant">
            <div className="form">
              <Formik
                initialValues={initialValues}
                validate={passwordValidator}
                validateOnChange
                onSubmit={handleConfirmPassword}
              >
                {(formikBag) => (
                  <Form className={classes.formStyle}>
                    {/* PASSWORD */}
                    <label>Enter New Password</label>
                    <Field name="password">
                      {({ field }) => (
                        <div className="py-2">
                          <Input
                            {...field}
                            type="password"
                            placeholder="Enter Password"
                            className="form-control login-placeholder"
                            onChange={(e) =>
                              formikBag.setFieldValue(
                                "password",
                                e.target.value
                              )
                            }
                          />
                          <p className="error">
                            {formikBag.touched.password &&
                              formikBag.errors.password}
                          </p>
                        </div>
                      )}
                    </Field>

                    {/* CONFIRM PASSWORD */}
                    <label>Confirm Password</label>
                    <Field name="confirmPassword">
                      {({ field }) => (
                        <div className="py-2">
                          <Input
                            {...field}
                            type="password"
                            placeholder="Confirm Password"
                            className="form-control login-placeholder"
                            onChange={(e) =>
                              formikBag.setFieldValue(
                                "confirmPassword",
                                e.target.value
                              )
                            }
                          />
                          <p className="error">
                            {formikBag.touched.confirmPassword &&
                              formikBag.errors.confirmPassword}
                          </p>
                        </div>
                      )}
                    </Field>

                    <button
                      type="submit"
                      disabled={isLoading || !formikBag.isValid}
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>

            <div className="forgotText" onClick={() => navigate("/")}>
              <IoArrowBackOutline /> Back to login page
            </div>
          </div>
        </div>
      </div>

      {isLoading && <Overlay />}
    </section>
  );
};

// redux
const mapStateToProps = (state) => ({
  userData: state.userData,
  locationData: state.locations,
  defaultState: state.defaultState,
});

const mapDispatchToProps = (dispatch) => ({
  setUsers: (updatedValue) =>
    dispatch({
      type: actionTypes.UPDATE_USER,
      updatedUser: updatedValue,
    }),
  setDefaultState: (updatedValue) =>
    dispatch({
      type: actionTypes.UPDATE_DEFAULT,
      updateDefault: updatedValue,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmPassword);
